import {combineReducers} from 'redux'
import Todoapp from './todo/reducer'
import Ecommerce from './ecommerce/product/reducer'
import Filters from './ecommerce/filter/reducer'
import Wishlist from './ecommerce/wishlist/reducer'
import Cart from './ecommerce/cart/reducer'
import ChatApp from './chap-app/reducer'
import EmailApp from './email/reducer'
import Customizer from './customizer/reducer'
import Bookmarkapp from './bookmark/reducer'
import Kyc, { kycInitialState } from './kyc/reducer'
import Policy, { policyInitialState } from './policy/reducer'
import wallet, { walletInitialState } from './wallet/reducer'
import Taskapp from './task-app/reducer'
import Projectapp from './project-app/reducer'
import login, { loginInitialState } from  './login/reducer'
import users, { usersInitialState } from  './users/reducer'
import sale, { saleInitialState } from './sales/reducer'
import affiliations, { affiliationsInitialState } from './affiliations/reducer'
import navision, { navisionInitialState } from './navision/reducer'
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import { LOGOUT } from './actionTypes';

const persistConfig = {
    key: 'root',
    storage,
    // whitelist: ['login'], // Reducers to persist but I have taken all reducers so instead of taking all reducers manually just disabled this key to take all reducers
  };

  const initialState = {
    login: loginInitialState,
    users: usersInitialState,
    sale: saleInitialState,
    affiliations: affiliationsInitialState,
    navision: navisionInitialState,
    Kyc: kycInitialState,
    Policy: policyInitialState,
    wallet: walletInitialState,
  };
  
const appReducer = combineReducers({
    Todoapp,
    data:Ecommerce,
    filters:Filters,
    Wishlistdata:Wishlist,
    Cartdata:Cart,
    ChatApp,
    EmailApp,
    Customizer,
    Bookmarkapp,
    Taskapp,
    Projectapp,
    login,
    users,
    sale,
    affiliations,
    navision,
    Kyc,
    Policy,
    wallet
});

const reducers = (state, action) => {
  if (action.type === LOGOUT) {
    state = { ...initialState };
  }
  return appReducer(state, action);
};

// export default reducers
export default persistReducer(persistConfig, reducers);